import React, { useEffect, useState } from "react";
import {
  Box,
  ButtonStyled,
  FormButtonStyled,
  LabelStyled,
  SpanStyled,
  TextStyled,
} from "../../../../components/styled/Elements";
import CustomRadioButton from "../../../../components/common/radioButtons/CustomRadio";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import ValidatedInput from "../../../../components/common/inputFields/ValidatedInput";
import { FileDown } from "../../../../components/styled/AllImages";
import ValidationErrorText from "../../../../components/common/inputFields/ValidationErrorText";
import { useLocation } from "react-router-dom";
import { formateAmounts } from "../../../../utils";
import { useDebounce } from "../../../../hooks/useDebounce";
import AuthApi from "../../../../services/api/authApi";
import { toast } from "react-toastify";

const SignupStep2 = ({
  planInfo,
  handleSteps,
  paymentMethod,
  bankInfo,
  totalAmount,
  setTotalAmount,
  setPaymentMethod,
  setValue,
  addLicenseFrm,
  register,
  watch,
  errors,
  promoDiscount,
  setPromoDiscount,
}) => {
  // const numOfLicenses = watch("number_of_licenses") || 0;
  const promoCode = watch("promotion_code") || "";
  const deboundedPromoCode = useDebounce(promoCode, 500);
  const [promoError, setPromoError] = useState("");
  const { t } = useTranslation();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const payment_method = searchParams.get("payment_method");

  const handleChange = (e) => {
    const { name, value } = e.target;

    setPaymentMethod(value);
    setValue(name, value);
  };

  const checkPromoCode = async (codeVal) => {
    try {
      const { data, message, code } = await AuthApi.checkPromo(codeVal);
      if (code === 200 && data?.discount) {
        setPromoDiscount(parseFloat(data?.discount));
        setPromoError(null);
      }
      if (code === 204) {
        setPromoDiscount(0);
        setPromoError({
          promotion_code: {
            type: "required",
            message: "invalid_promo_code",
          },
        });
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (deboundedPromoCode) checkPromoCode(deboundedPromoCode);
    else setPromoDiscount(0)
  }, [deboundedPromoCode]);

  useEffect(() => {
    if (planInfo?.amount) {
      const baseCost = parseFloat(planInfo?.amount);
      const discount = baseCost * (parseFloat(promoDiscount) / 100);

      const vatAmount =
        (parseFloat(bankInfo?.vat) / 100) * (baseCost - (discount || 0));
      const totalAmount =
        parseFloat(baseCost - discount || 0) + parseFloat(vatAmount.toFixed(2));

      setTotalAmount(totalAmount);
      // setTotalAmount(totalAmount.toFixed(2));
    }
  }, [promoDiscount]);

  return (
    <Step2Wrapper>
      <Box>
        <Box>
          <ValidatedInput
            name="promotion_code"
            label={"promo_code_optional"}
            type="input"
            fieldType="text"
            placeholder={"promo_code"}
            className={"mb-3 combined flex-wrap p-0"}
            bg="var(--white)"
            value={promoCode}
            outline={true}
            register={register}
            errors={promoError}
            validationRules={{
              required: false,
            }}
          />
          {/* <ValidatedInput
            name="number_of_licenses"
            label={"num_of_licenses"}
            type="input"
            fieldType="number"
            placeholder={"numOfLicensePlaceholder"}
            className={"mb-3 combined flex-wrap p-0"}
            bg="var(--white)"
            register={register}
            errors={errors}
            validationRules={{
              required: true,
            }}
          /> */}
        </Box>

        {addLicenseFrm && (
          <Box className="mb-3">
            <Box>
              <LabelStyled
                size="16px"
                weight="bold"
                color="var(--text)"
                className="mb-1"
              >
                {t("ProfessionalPlan")}
              </LabelStyled>
            </Box>
            <Box className="d-flex gap-3">
              <CustomRadioButton
                name="plan-type"
                label={t("SAR300perusermonth")}
                value={1}
                checked={"checked"}
                className="w-auto"
                // onChange={handleChange}
              />
            </Box>
          </Box>
        )}

        <Box className="d-flex justify-content-between align-items-center flex-wrap gap-3 my-4">
          <Box>
            <TextStyled
              size="18px"
              color="var(--themeColor)"
              className="align-items-sm-baseline"
              weight="700"
            >
              {t("total")}: {formateAmounts(totalAmount)} {t("usd")}
              <SpanStyled size="14px">
                &nbsp; &nbsp;
                {t("inc_tax")}
              </SpanStyled>
            </TextStyled>
          </Box>
          {/* {!addLicenseFrm && (
            <Box>
              <ButtonStyled
                label={t("download_invoice")}
                border="var(--themeColor)"
                color="var(--themeColor)"
                bg="var(--white)"
                shadow="none"
                size="14px"
                type="button"
                icon={FileDown}
              />
            </Box>
          )} */}
        </Box>
        <Box className="mb-3">
          <Box>
            <LabelStyled
              size="16px"
              weight="bold"
              color="var(--text)"
              className="mb-1"
            >
              {t("choose_payment_method")}
            </LabelStyled>
          </Box>
          <Box className="d-flex gap-3">
            <CustomRadioButton
              name="payment_method"
              label={t("card")}
              value={"card"}
              checked={paymentMethod === "card"}
              disabled={payment_method && payment_method !== "card"}
              register={register}
              validationRules={{
                required: true,
                onChange: handleChange,
              }}
            />

            <CustomRadioButton
              name="payment_method"
              label={t("bank_transfer")}
              value={"bank_transfer"}
              checked={paymentMethod === "bank_transfer"}
              disabled={payment_method && payment_method !== "bank_transfer"}
              register={register}
              validationRules={{
                required: true,
                onChange: handleChange,
              }}
            />
          </Box>
          {errors?.payment_method?.type === "required" && (
            <ValidationErrorText
              text={
                t(errors?.payment_method?.message) ||
                `${t("payment_method")} ${t("isRequired")}.`
              }
            />
          )}
        </Box>
      </Box>
      <FormButtonStyled
        label={t("next")}
        color="var(--white)"
        bg="var(--themeColor)"
        className="w-100"
        clName="w-100 my-4"
        type="button"
        disabled={!paymentMethod}
        onClick={handleSteps}
      />
    </Step2Wrapper>
  );
};

export default SignupStep2;

const Step2Wrapper = styled.div``;
